import { QueryClient } from "react-query"

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            cacheTime: import.meta.env.PROD ? 1000 * 60 * 5 : 0,
            staleTime: import.meta.env.PROD ? 1000 * 60 * 2 : 0,
            retry: import.meta.env.PROD ? 3 : 1,
        },
    },
})
